/**
 * Admin Users Repository
 */

import { createRepository } from 'data/utils/createRepository';

const adminUsersRepository = createRepository({
	endpoint: 'admin/users',
	name: 'adminUsers',
	statePath: 'adminUsersRepo', // Must match the key in store.js
});

export const {
	name,
	statePath,
	thunks: adminUsersThunks,
	reducer: adminUsersReducer,
	actions: adminUsersActions,
	types: adminUsersTypes,
	selectors: adminUsersSelectors,
	useHook: useAdminUsers,
} = adminUsersRepository;

export default adminUsersRepository;
